// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadProtocolFileRequest
 */
export interface UploadProtocolFileRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadProtocolFileRequest
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof UploadProtocolFileRequest
     */
    upload_id: string;
}

/**
 * Check if a given object implements the UploadProtocolFileRequest interface.
 */
export function instanceOfUploadProtocolFileRequest(value: object): value is UploadProtocolFileRequest {
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('upload_id' in value) || value['upload_id'] === undefined) return false;
    return true;
}

export function UploadProtocolFileRequestFromJSON(json: any): UploadProtocolFileRequest {
    return UploadProtocolFileRequestFromJSONTyped(json, false);
}

export function UploadProtocolFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadProtocolFileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'file_name': json['file_name'],
        'upload_id': json['upload_id'],
    };
}

export function UploadProtocolFileRequestToJSON(json: any): UploadProtocolFileRequest {
    return UploadProtocolFileRequestToJSONTyped(json, false);
}

export function UploadProtocolFileRequestToJSONTyped(value?: UploadProtocolFileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_name': value['file_name'],
        'upload_id': value['upload_id'],
    };
}
